import Script from 'next/script'

interface MouseflowProps {
  enabled: boolean
  posKey?: string
}

const loadMouseflow = (posKey?: string) => (
  <Script
    id="mouse-flow"
    strategy="afterInteractive"
    dangerouslySetInnerHTML={{
      __html: `
        window._mfq = window._mfq || [];
        ${posKey ? `window._mfq.push(["newPageView", "/${posKey}"]);` : ``}
        (function() {
            var mf = document.createElement("script");
            mf.type = "text/javascript"; mf.defer = true;
            mf.src = "//cdn.mouseflow.com/projects/b837e449-83ee-457f-9ef5-8f976953f2bc.js";
            document.getElementsByTagName("head")[0].appendChild(mf);
        })();`,
    }}
  />
)

const Mouseflow = (props: MouseflowProps) => (
  <>{props.enabled && loadMouseflow(props.posKey)}</>
)

export default Mouseflow
